import React from 'react';

const Reload = props => (
  <svg
    id="component_337_1"
    data-name="component 337 – 1"
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    {...props}
  >
    <g id="SEGMENTATION">
      <g id="group_9792" data-name="group 9792">
        <path
          id="path_1641"
          data-name="path 1641"
          d="M0,0V32H32V0ZM31.333,31.333H.667V.667H31.333Z"
          fill="none"
        />
      </g>
    </g>
    <g
      id="group_9793"
      data-name="group 9793"
      transform="translate(5.833 3.292)"
    >
      <path
        id="path_1643"
        data-name="path 1643"
        d="M45.167,24.833V19.75L51.521,26.1l-6.354,6.354V27.375A7.625,7.625,0,1,0,52.792,35h2.542A10.167,10.167,0,1,1,45.167,24.833Z"
        transform="translate(-35 -19.75)"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default Reload;
